import { ClassesBuilder } from '@utilities';

const classesConfig = {
  container: 'flex items-center justify-center relative',
  hexagon: 'absolute inset-0 z-0 w-full h-full',
  icon: 'h-full w-full flex inline-flex justify-center items-center text-white z-10',
};

export default new ClassesBuilder(classesConfig);
